import { Link } from "react-router-dom";

export default function CommentReminderField({ shopOn, v, set }) {
  if (shopOn == null) return null;
  if (!shopOn)
    return (
      <div className="hint" data-testid="offer-cr-shop-off">
        Påmindelse i kommentaren er slået fra for butikken – <Link to="/settings">slå til under Indstillinger</Link>
      </div>
    );
  return (
    <label className="check">
      <input type="checkbox" checked={v.comment_reminder} onChange={set("comment_reminder")} data-testid="offer-comment-reminder" /> Påmind i
      kommentaren for dette tilbud
    </label>
  );
}
